import { render, staticRenderFns } from "./invoice-full-details.vue?vue&type=template&id=4de0b70c&scoped=true&"
import script from "./invoice-full-details.vue?vue&type=script&lang=ts&"
export * from "./invoice-full-details.vue?vue&type=script&lang=ts&"
import style0 from "./invoice-full-details.vue?vue&type=style&index=0&id=4de0b70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de0b70c",
  null
  
)

export default component.exports